import { render } from "./Error404API.vue?vue&type=template&id=018adf6e"
import script from "./Error404API.vue?vue&type=script&lang=js"
export * from "./Error404API.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__